import { useMemo } from 'react'
import { useQuery } from '@tanstack/react-query'
import { AxiosResponse } from 'axios'
import { axiosInstance } from '../helpers/axios'
import {
    ConversationProblem,
    ConversationProblemsResponse,
} from '../components/AdminPanel/Lori Manager/analysisTypes'

export const CONVERSATION_PROBLEMS_BY_IDS_KEY = 'loriConversationProblemsByIds'

const PROBLEMS_BASE_PATH = '/chat/conversation-problems/'

function normalizeConversationIds(conversationIds: number[]): number[] {
    return Array.from(new Set(conversationIds)).sort((a, b) => a - b)
}

export function buildProblemsByConversationId(
    results: ConversationProblem[],
): Map<number, ConversationProblem> {
    const map = new Map<number, ConversationProblem>()
    for (const problem of results) {
        map.set(problem.conversation, problem)
    }
    return map
}

export const useConversationProblemsByIds = (
    conversationIds: number[],
    enabled: boolean,
) => {
    const sortedIds = useMemo(() => normalizeConversationIds(conversationIds), [
        conversationIds,
    ])

    const query = useQuery<AxiosResponse<ConversationProblemsResponse>>({
        queryKey: [CONVERSATION_PROBLEMS_BY_IDS_KEY, sortedIds.join(',')],
        queryFn: () =>
            axiosInstance.get(PROBLEMS_BASE_PATH, {
                params: {
                    conversation_ids: sortedIds.join(','),
                    page_size: sortedIds.length,
                },
            }),
        enabled: enabled && sortedIds.length > 0,
        staleTime: 60 * 1000,
        refetchOnWindowFocus: false,
    })

    const problemsByConversationId = useMemo(
        () => buildProblemsByConversationId(query.data?.data?.results ?? []),
        [query.data],
    )

    return {
        problemsByConversationId,
        isLoading: query.isLoading,
    }
}
